
import React from 'react'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'

const DateField = ({ label, name, validation }) => (
  <div className="mb-3 flex-1 customeDate">
    <label>{label}</label>
    <DatePicker
      style={{ width: '100%' }}
      value={validation.values?.[name] ? dayjs(validation.values?.[name]) : ''}
      onChange={(_, dateString) => validation.setFieldValue(name, dateString)}
      onBlur={validation.handleBlur}
    />
    {validation.touched[name] && validation.errors[name] && (
      <p className="text-danger">{validation.errors[name]}</p>
    )}
  </div>
)

export default DateField
